module.exports = __webpack_public_path__ + "img/img_83821_0_9.17afa4f2.jpeg";